<template>
  <div>
    <template v-if="!isTablet">
      <b-popover
        :target="computedTarget"
        variant="light"
        triggers="click"
        placement="bottom"
        ref="popover"
      >
        <template v-slot:title>
          Selecione a etapa que deseja mover este card
        </template>
        <b-form-select
          v-model="selectedOption"
          :options="options"
        >
        </b-form-select>
        <DefaultButton
          btnVariant="btn-third justify-content-center"
          :onClick="confirmSelection"
          icon="fas fa-check-circle"
          text="Salvar"
        />
      </b-popover>
    </template>
    <template v-else>
      <b-modal
        scrollable
        centered
        :visible="true"
        :hide-footer="true"
        @hide="destroyModal"
        @close="destroyModal"
      >
        <template #modal-title>
          Selecione a etapa que deseja mover este card
        </template>

        <template v-slot:title>
          Selecione a etapa que deseja mover este card
        </template>
        <b-form-select
          v-model="selectedOption"
          :options="options"
        >
        </b-form-select>
        <DefaultButton
          btnVariant="btn-third justify-content-center"
          :onClick="confirmSelection"
          icon="fas fa-check-circle"
          text="Salvar"
        />
      </b-modal>
    </template>
    <EventManager
      v-if="columnEvents"
      :key="card.id"
      ref="EventManager"
      :eventsToShow="columnEvents"
      :colunaDestino="selectedBoard"
      :card="card"
      @Submited="submitedEvents"
      @Aborted="abortedEvents"
    ></EventManager>
  </div>
</template>

<script>
import DefaultButton from '@/components/UI/button/defaultButton.vue'
import BoardRepositoryV2 from '@/shared/http/repositories/crm/board_v2.js'
import { toast } from '@/shared/utils/UIHelper'
import EventManager from '@/views/private/crm/board/modal/event/EventManager.vue'

export default {
  name: 'MoveCardPopover',
  components: {
    DefaultButton,
    EventManager
  },
  props: {
    card: {
      type: Object,
      required: true
    },
    idCurrentBoard: {
      type: Number,
      required: true
    },
    bondId: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      selectedOption: null,
      options: [],
      eventsSubmited: false,
      columnEvents: null,
      selectedBoard: null,
      isTablet: screen.width <= 1000,
      localBoardColumns: []
    }
  },
  mounted () {
    this.getBoardColumns(this.card.boardColumn.board.id)
  },
  computed: {
    computedTarget () {
      return this.bondId ? this.bondId : 'moveBtn'
    }
  },
  methods: {
    destroyModal () {
      this.$emit('close')
    },
    getBoardColumns (boardId) {
      if (boardId) {
        BoardRepositoryV2.Column_GetAllActive(boardId)
          .then((res) => {
            this.localBoardColumns = res.data.content // Atribuímos os dados à variável local
            let sortedContent = this.localBoardColumns.sort(
              (a, b) => a.posicao - b.posicao
            )
            this.options = sortedContent
              .filter((x) => x.id != null)
              .map((x) => ({ value: x.id, text: x.nome }))
          })
          .catch(this.onException)
      }
    },
    submitedEvents (obj) {
      this.eventsSubmited = true
      this.confirmSelection()
    },
    abortedEvents () {
      this.columnEvents = null
    },
    confirmSelection () {
      this.onMoveCard(this.card, this.selectedOption, 1)
    },
    onMoveCard (card, newBoardColumnId, newIndex) {
      if (card) {
        let moveCardData = {
          id: card.id,
          newPosition: newIndex,
          newColumn: newBoardColumnId
        }

        let dataInicioSituacao = new Date().toISOString()
        this.selectedBoard = this.localBoardColumns.find(
          (board) => board.id === newBoardColumnId
        )
        let noObrigatoryEvent =
          !this.selectedBoard.eventoColuna.length ||
          this.selectedBoard.eventoColuna.some((event) => event === 0)

        if (!noObrigatoryEvent && !this.eventsSubmited) {
          toast.warning(
            `Existem eventos obrigatórios cadastrados para a etapa selecionada!`,
            'Atenção'
          )
          this.columnEvents = this.selectedBoard.eventoColuna
          return
        }

        if (this.verifyRequiredColumns(this.idCurrentBoard, newBoardColumnId)) {
          BoardRepositoryV2.Card_MoveCardColumns(
            this.card.boardColumn.board.id,
            this.card.boardColumn.id,
            this.card.id,
            moveCardData
          )
            .then((response) => {
              toast.info(`O Card foi movido!`, 'Sucesso!')
              this.$emit('moved', this.selectedOption, card, dataInicioSituacao)
            })
            .catch(this.onException)
        }
      }
    },
    verifyRequiredColumns (oldBoardColumnId, newBoardColumnId) {
      let newBoardColumnIndex = this.localBoardColumns.findIndex(
        (c) => c.id === newBoardColumnId
      )
      let oldBoardColumnIndex = this.localBoardColumns.findIndex(
        (c) => c.id === oldBoardColumnId
      )

      if (
        newBoardColumnIndex > oldBoardColumnIndex &&
        newBoardColumnIndex - oldBoardColumnIndex > 1
      ) {
        for (let i = oldBoardColumnIndex + 1; i < newBoardColumnIndex; i++) {
          let passedBoardColumn = this.localBoardColumns[i]

          if (passedBoardColumn.obrigatorio === true) {
            toast.warning(
              `A passagem pela coluna ${passedBoardColumn.nome} é obrigatória!`
            )
            return false
          }
        }
      }

      return true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/components/moveCardColumn/moveCardColumn.vue